export type VectorSignedPath = {
  mapId: string;
  vectorId: string;
  audience_b64: string;
  tile_sig: string;
  tile_exp: string;
  mapFeaturesUrls: {
    features: string;
    count: string;
    fields: string;
    fieldCategoriesTemplate: string;
  };
};

interface Config {
  API_URL: string;
  /** MVT tiles + `/v1/map-features/*`; defaults to {@link API_URL} when empty. */
  VECTOR_SERVICE_URL: string;
  MEDIA_URL: string;
  JWT_NAME: string;
  POINTS_URL: string;
  COOKIE_DOMAIN?: string; // Not required in development
  getVectorSignedAccess?: (args: {
    layerId: string;
  }) => VectorSignedPath | undefined;
  remintVectorSignedAccess?: (layerId: string) => Promise<void>;
}

export const config: Config = {
  API_URL: '',
  VECTOR_SERVICE_URL: '',
  MEDIA_URL: '',
  JWT_NAME: 'jwt',
  POINTS_URL: '',
};

export function setOpts(partialOptsObject: Partial<Config>): void {
  Object.assign(config, partialOptsObject);
}
